import { ExteriorPageNumber, InteriorPageNumber, MechanicalPageNumber } from './index'
export const pageObject = {
    Exterior: ExteriorPageNumber,
    Interior: InteriorPageNumber,
    Mechanical: MechanicalPageNumber
}